import { ECOSYSTEM } from "@/data/content";
import { Reveal, ChapterBadge } from "@/components/Reveal";

export default function Ecosystem() {
  return (
    <section data-testid="ecosystem-section" className="py-20 sm:py-28 bg-surface-muted/60 border-y border-charcoal-900/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ChapterBadge number="06" label="Scope & Breadth" />
        <Reveal className="mt-8 max-w-2xl">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-charcoal-900 leading-[1.1]">
            A complete <em className="italic text-copper-600">creative ecosystem.</em>
          </h2>
          <p className="mt-4 text-base sm:text-lg text-charcoal-600 leading-relaxed">
            The range of creative work handled across brands, channels and formats — from identity
            systems to pre-press production.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {ECOSYSTEM.map((cat, i) => (
            <Reveal key={cat.title} delay={Math.min(i * 0.05, 0.3)} className={i === 2 || i === 5 ? "lg:row-span-1" : ""}>
              <div
                data-testid={`ecosystem-card-${i}`}
                className="h-full bg-surface-white border border-charcoal-900/10 rounded-2xl p-6 hover:border-copper-600/30 transition-colors duration-300"
              >
                <h3 className="font-serif text-xl text-charcoal-900">{cat.title}</h3>
                <div className="mt-4 flex flex-wrap gap-1.5">
                  {cat.items.map((item) => (
                    <span
                      key={item}
                      className="text-xs text-charcoal-600 bg-surface-muted border border-charcoal-900/5 rounded-full px-2.5 py-1"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
